function HandleHeaderAnchorClick(event) {
  var searchContainer = document.querySelector(
    ".bridgman-header-search-mobile"
  );

  if (searchContainer.classList.contains("hidden")) {
    searchContainer.classList.remove("hidden");
  } else {
    searchContainer.classList.add("hidden");
  }
}

function handleMobHeaderHeight() {
  var mobNavBar = document.getElementById("mobileNavBar");
  mobNavBarHeight = mobNavBar.offsetHeight;
  if (document.getElementsByClassName("bridgman-announcement-bar-container")[0] != undefined) {
    var announcementBar = document.getElementsByClassName("bridgman-announcement-bar-container")[0].offsetHeight;
    var topRowHeader = document.querySelector(".bridgman-header-top-container");
  }

  if (topRowHeader != undefined) {
    if (window.innerWidth <= 480) {
      topRowHeader.style.marginTop = mobNavBarHeight + announcementBar + "px";
    } else {
      topRowHeader.style.marginTop = "0px";
    }
  }
}

window.addEventListener("DOMContentLoaded", function (e) {
  $(".lightning-header-anchor").on("click", function (event) {
    HandleHeaderAnchorClick(event);
  });
});

// window.addEventListener("load", function (e) {
//   handleMobHeaderHeight();
// });

// window.addEventListener("resize", function (e) {
//   handleMobHeaderHeight();
// });
